export default __webpack_public_path__ + "static/media/ee.bd7c5747.svg";